// What the browser and the Worker agree on about analytics. See docs/analytics.md.

/**
 * Where the browser sends events. The Worker passes them on to PostHog, so the page's Content-Security-Policy stays
 * at 'self'. PostHog advises against a name like /analytics or /posthog, which ad blockers look for.
 */
export const ANALYTICS_RELAY = '/relay';

/** The policy says what's collected, and lives on the marketing site. Every environment of the game links to this one. */
export const PRIVACY_URL = 'https://riftcrawl.com/privacy';

/** Sent to the browser by /api/config. Absent if this server has no PostHog project. */
export interface AnalyticsConfig {
  /** The project's public token. It can only send events, and it's in every player's browser anyway. */
  key: string;
  env: string;
}
